import React from 'react';

import { EditActionBtn, SaveActionBtn, CancelActionBtn, AddActionBtn } from 'src/buttons';

import FormErrors from './FormErrors';
import styles from './EditableListButtons.scss';

const EditableListButtons = ({ mode, errors, onEdit, onSave, onCancel, onAddRow, anyApiRunning }) => (
  <div>
    {mode === 'SHOW' ? (
      <div>
        <EditActionBtn onClick={onEdit} disabled={anyApiRunning} />
      </div>
    ) : (
      <div className={styles.action}>
        <SaveActionBtn onClick={onSave} />
        <CancelActionBtn onClick={onCancel} />
        <AddActionBtn onClick={onAddRow} label="Add" />
      </div>
    )}
    <FormErrors errors={errors} />
  </div>
);

export default EditableListButtons;
